module.exports = __webpack_public_path__ + "img/9788925509648.762cb025.jpg";